/* Ardor Printing AI flag generator (sections/ardor-flag-idea.liquid, template page.ai-flag-generator). 2026-10-11.
   Ported from the AI banner generator (assets/ardor-banner-idea.js): same look, Turnstile and email-unlock flow, the
   same visitor id + email (localStorage wsIdeaVisitor / wsIdeaEmail) and the same worker routes and counters
   (/api/banner/quota, /logo, /generate with product "banner", /fix, /final), so tries are shared with the banner tool.
   The customer picks a flag (keys as in the flag designer: FA-*, FC-*, FE-16, TD-*, RC-*, PF-*). Feather and rectangle
   flags with "Words run up the flag" ask for a LANDSCAPE design (widthFt = face height, heightFt = face width; the
   worker clamps it to 3:1 with plain extendable ends) shown turned 90 degrees counter-clockwise on the flag outline,
   ends filled from the design's own edges. Teardrops, desktop and pole flags use the face's own proportions.
   "Use this design" -> /api/banner/final -> <builder>?ai=<finalId>&flag=<KEY>&rot=<-90|0>&sides=1[&ends=smooth]
   [&logo=<logoId>&lb=x0,y0,x1,y1], plus sessionStorage ardorFlagAiPick (format: FL-AI ai/HANDOFF.md).
   Before redirecting it fires a cancelable "ardor:flag-ai-handoff" event on the section (detail.url, detail.pick);
   calling preventDefault() on it stops the redirect (used for testing).
   No jQuery and no libraries except Cloudflare Turnstile. */
(function () {
  'use strict';
  const root = document.querySelector('[data-ardor-flag-ai]');
  if (!root || root.dataset.abiReady) return;
  root.dataset.abiReady = '1';

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));
  const API = (root.dataset.api || '').replace(/\/+$/, '');
  const SITEKEY = root.dataset.turnstile || '';
  const BUILDER = root.dataset.builder || '/products/custom-flags';
  const MIN_FT = 0.5; // the worker's banner mode takes 0.5 .. 200 ft per side
  const MAX_FT = 200;
  const MAX_LOGO_PX = 1536;
  const MAX_LOGO_BYTES = 8 * 1024 * 1024;
  const MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  const LIMITS = { headline: 60, subline: 80, details: 120, notes: 300, fix: 200 };
  const STYLES = { bold: 'Bold', clean: 'Clean', fun: 'Fun', elegant: 'Elegant', vintage: 'Vintage', event: 'Event' };
  const LAST_KEY = 'ardorFlagAiLast';
  const PICK_KEY = 'ardorFlagAiPick';
  // [seconds, status text, step index (Layout, Your words, Spell check, Final touches), only when]
  const GEN_STEPS = [
    [0, 'Laying out your flag…', 0],
    [10, 'Setting your words…', 1],
    [22, 'Placing your logo…', 1, 'logo'],
    [34, 'Checking the spelling…', 2],
    [50, 'Double-checking every word…', 2],
    [66, 'Adding the final touches…', 3],
    [82, 'Almost there…', 3]
  ];

  /* ---------- storage (same keys as the sticker generator for visitor + email) ---------- */
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  const sget = (k) => { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const sset = (k, v) => { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* full or blocked */ } };

  let visitor = store.get('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store.set('wsIdeaVisitor', visitor);
  }
  let email = store.get('wsIdeaEmail') || '';

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }

  /* ---------- elements ---------- */
  const form = $('[data-abi-form]');
  const typeChips = $$('[data-afl-types] .abi__chip');
  const sizeRow = $('[data-afl-sizes]');
  const dirRow = $('[data-afl-dir]');
  const dirChips = $$('.abi__chip', dirRow);
  const shapeBox = $('[data-afl-shape-art]');
  const shapeLabel = $('[data-abi-shape-label]');
  const sizeNote = $('[data-abi-size-note]');
  const sizeErr = $('[data-abi-size-err]');
  const drop = $('[data-abi-drop]');
  const fileIn = $('[data-abi-file]');
  const logoRow = $('[data-abi-logo]');
  const logoImg = $('[data-abi-logo-img]');
  const logoName = $('[data-abi-logo-name]');
  const logoInfo = $('[data-abi-logo-info]');
  const logoErr = $('[data-abi-logo-err]');
  const lineIns = { headline: $('[data-abi-line="headline"]'), subline: $('[data-abi-line="subline"]'), details: $('[data-abi-line="details"]') };
  const headErr = $('[data-abi-headline-err]');
  const notesIn = $('[data-abi-notes]');
  const styleBtns = $$('[data-style]');
  const goBtn = $('[data-abi-go]');
  const goLabel = $('[data-abi-go-label]');
  const quotaEl = $('[data-abi-quota]');
  const errEl = $('[data-abi-err]');
  const results = $('[data-abi-results]');
  const metaEl = $('[data-abi-meta]');
  const echo = $('[data-abi-echo]');
  const h2 = $('[data-abi-h2]');
  const statusEl = $('[data-abi-status]');
  const loading = $('[data-abi-loading]');
  const bar = $('[data-abi-bar]');
  const stepEls = $$('[data-abi-steps] li');
  const grid = $('[data-abi-grid]');
  const againRow = $('[data-abi-again-row]');
  const againBtn = $('[data-abi-again]');
  const editBtn = $('[data-abi-edit]');
  const fineEl = $('.abi__fine');
  const gate = $('[data-abi-gate]');
  const gateForm = $('[data-abi-gate-form]');
  const gateEmail = $('[data-abi-email]');
  const gateErr = $('[data-abi-gate-err]');
  const gateN = $('[data-abi-gate-n]');

  const S = {
    flag: 'FA-L', dir: 'up', pref: 'up', rot: -90, w: 0, h: 0, style: 'bold',
    logo: null, // { blob, w, h, name, id, thumb (object URL or data URL), thumbData }
    batch: null, // { batchId, aspect, clamped, w, h, style, notes, lines, logoId, images }
    busy: false, off: false,
    bannersLeft: null, fixesLeft: null, finalsLeft: null,
    hasEmail: !!email, freeBanners: 2, emailBanners: 10,
    pending: null
  };

  if (!API) {
    goBtn.disabled = true;
    quotaEl.hidden = true;
    return;
  }

  /* ---------- small helpers ---------- */
  const clean = (s) => String(s || '').replace(/\s+/g, ' ').trim();
  const round2 = (n) => Math.round(n * 100) / 100;
  const fmt = (n) => String(round2(n));
  const sizeLabel = (w, h) => `${fmt(w)} x ${fmt(h)} ft`;
  const num = (v) => { const n = parseFloat(String(v).replace(',', '.')); return Number.isFinite(n) ? n : NaN; };
  const validFt = (n) => Number.isFinite(n) && n >= MIN_FT && n <= MAX_FT;
  const clampAr = (a) => Math.min(3, Math.max(1 / 3, a));
  const shapeOf = (a) => (a >= 6 ? 'xwide' : a >= 1.3 ? 'wide' : a > 0.77 ? 'square' : 'tall');
  const enc = encodeURIComponent;

  /* ---------- flags ---------- */
  // Keys match the flag designer (/products/custom-flags). w x h = printed graphic in inches (graphicIn, the bounding
  // box of the cut line), flag standing upright, Print Thru (pole sleeve on the left seen from the front). o = cut
  // outline in inches from the top-left of that box. Both from FL-SPECS specs/flag-shapes.json (supplier templates,
  // Oct 11 2026). The black nylon sleeve is sewn onto the pole edge OUTSIDE the print, so the whole outline is
  // printed; sl = sleeve width drawn in the previews only (inches, not measured). safe = safe inset (inches).
  // Pole flags (PF-*) have no template: plain rectangles 36 x 24, 60 x 36, 72 x 48 in. d: 1 = default size.
  const FLAG_TYPES = {
    'feather-angled': { label: 'Feather, angled', short: 'feather flag', dirs: true },
    'feather-convex': { label: 'Feather, rounded', short: 'feather flag', dirs: true },
    'feather-econo': { label: 'Econo feather', short: 'feather flag', dirs: true },
    teardrop: { label: 'Teardrop', short: 'teardrop flag', dirs: false },
    rectangle: { label: 'Rectangle', short: 'rectangle flag', dirs: true },
    'pole-flag': { label: 'Pole flag', short: 'pole flag', dirs: false }
  };
  const FLAGS = [
    { k: 'FA-S', t: 'feather-angled', shape: 'feather-angled', s: 'Small', ft: '9 ft', w: 23.62, h: 78.72, sl: 1.25, safe: 2,
      o: [[23.6,0.1],[22.8,0],[21.6,0],[20,0],[19.1,0.1],[18.2,0.1],[17.3,0.2],[16.5,0.4],[15.6,0.5],[14.5,0.9],[13.9,1.1],[13.1,1.5],[12.3,1.9],[11.4,2.4],[10.5,3],[9.5,3.6],[8.6,4.5],[7.7,5.4],[6.6,6.6],[6,7.4],[5.7,7.9],[5.3,8.6],[4.8,9.3],[4.4,10.1],[3.9,10.9],[3.5,11.9],[3,12.9],[2.6,13.9],[2.2,15.3],[1.7,17.1],[1.3,18.9],[0.8,20.9],[0.6,22.1],[0.5,23.2],[0.3,24.5],[0.2,25.7],[0,28.6],[0.2,78.7],[23.6,68.3]] },
    { k: 'FA-M', t: 'feather-angled', shape: 'feather-angled', s: 'Medium', ft: '10.5 ft', w: 24, h: 104, sl: 1.25, safe: 2,
      o: [[24,90.2],[0,104],[0,42],[0,40.5],[0.1,38.8],[0.2,36.5],[0.4,33.9],[0.7,30.9],[1.1,27.7],[1.7,24.4],[2.5,21],[3.5,17.7],[4.6,14.5],[6,11.6],[7.7,9.1],[9.6,6.9],[11.5,5.1],[13.5,3.7],[15.5,2.5],[17.4,1.6],[19.1,1],[20.7,0.6],[22.1,0.3],[23.1,0.1],[24,0]] },
    { k: 'FA-L', t: 'feather-angled', shape: 'feather-angled', s: 'Large', ft: '14 ft', w: 28.03, h: 138, sl: 1.25, safe: 2, d: 1,
      o: [[28,122],[0,138],[0,50],[0,48.4],[0,46.5],[0.1,44],[0.3,41],[0.6,37.6],[1.1,34],[1.8,30],[2.8,25.9],[4.1,21.9],[5.7,17.8],[7.6,13.9],[9.7,10.7],[11.8,8],[14.1,5.9],[16.4,4.1],[18.6,2.8],[20.8,1.7],[22.7,1],[24.5,0.5],[25.9,0.2],[27.1,0.1],[28,0]] },
    { k: 'FA-XL', t: 'feather-angled', shape: 'feather-angled', s: 'XL', ft: '18 ft', w: 24.11, h: 183.68, sl: 1.25, safe: 2,
      o: [[24,170],[24,169.9],[0,183.7],[0.2,28.9],[0.3,28.4],[0.4,27.2],[0.7,25.2],[1.3,22.8],[2.2,19.9],[3.6,16.8],[5.4,13.5],[7.7,10.2],[10.7,7.1],[14.4,4.3],[18.8,1.9],[24.1,0]] },
    { k: 'FC-S', t: 'feather-convex', shape: 'feather-convex', s: 'Small', ft: '9 ft', w: 23.62, h: 78.72, sl: 1.25, safe: 2,
      o: [[23.6,43.3],[23.6,0.1],[22.8,0],[21.6,0],[20,0],[19.1,0.1],[18.2,0.1],[17.4,0.2],[16.5,0.4],[15.6,0.5],[15,0.7],[14.5,0.9],[13.9,1.1],[13.1,1.5],[12.3,1.9],[11.4,2.4],[10.5,2.9],[9.6,3.6],[8.6,4.4],[7.7,5.4],[6.6,6.6],[6,7.4],[5.7,7.9],[5.3,8.6],[4.8,9.3],[4.4,10.1],[3.9,10.9],[3.5,11.9],[3,12.9],[2.6,13.9],[2.3,15],[2,15.8],[1.7,17.1],[1.5,17.9],[1.1,19.9],[0.8,20.9],[0.6,22.1],[0.5,23.2],[0.3,24.5],[0.2,25.7],[0,28.6],[0.2,78.7],[1,78.6],[1.9,78.4],[3.1,78.2],[4.5,77.8],[6.1,77.2],[7.9,76.5],[9.7,75.7],[11.6,74.6],[13.5,73.3],[15.4,71.9],[17.2,70.1],[18.3,68.8],[19.3,67.4],[20.2,66],[21,64.5],[21.6,63],[22.1,61.6],[22.6,60.1],[22.9,58.7],[23.2,57.4],[23.4,56.1],[23.5,54.9],[23.6,53.8]] },
    { k: 'FC-M', t: 'feather-convex', shape: 'feather-convex', s: 'Medium', ft: '10.5 ft', w: 24, h: 104, sl: 1.25, safe: 2,
      o: [[17.1,94.2],[15.4,96],[13.5,97.5],[11.6,98.9],[9.7,100.1],[7.9,101.1],[6.1,101.9],[4.4,102.6],[3,103.1],[1.8,103.5],[0.8,103.8],[0,104],[0,41.6],[0,40.5],[0.1,38.8],[0.2,36.5],[0.4,33.9],[0.7,30.9],[1.1,27.7],[1.7,24.4],[2.5,21],[3.5,17.7],[4.6,14.5],[6,11.6],[7.7,9.1],[9.6,6.9],[11.5,5.1],[13.5,3.7],[15.5,2.5],[17.4,1.6],[19.2,1],[20.8,0.6],[22.1,0.3],[23.1,0.1],[24,0],[24,73.7],[24,74.4],[23.9,75.5],[23.8,77],[23.6,78.8],[23.2,80.8],[22.8,83],[22.1,85.2],[21.2,87.6],[20.1,89.9],[18.7,92.1]] },
    { k: 'FC-L', t: 'feather-convex', shape: 'feather-convex', s: 'Large', ft: '14 ft', w: 28.03, h: 138, sl: 1.25, safe: 2, d: 1,
      o: [[28,100.7],[27.9,102],[27.8,103.4],[27.6,105.3],[27.1,107.6],[26.6,110.1],[25.8,112.9],[24.9,115.7],[23.6,118.6],[22.1,121.4],[20.3,124.1],[18.1,126.6],[16.1,128.5],[14,130.2],[11.9,131.8],[9.9,133.1],[7.9,134.3],[6.1,135.3],[4.4,136.1],[3,136.8],[1.7,137.3],[0.8,137.7],[0,138],[0,50],[0,48.4],[0,46.5],[0.1,44],[0.3,41],[0.6,37.6],[1.1,34],[1.8,30],[2.8,25.9],[4.1,21.9],[5.7,17.8],[7.6,13.9],[9.7,10.7],[11.8,8],[14.1,5.9],[16.4,4.1],[18.6,2.8],[20.8,1.7],[22.7,1],[24.5,0.5],[25.9,0.2],[27.1,0.1],[28,0]] },
    { k: 'FC-XL', t: 'feather-convex', shape: 'feather-convex', s: 'XL', ft: '18 ft', w: 24.11, h: 183.68, sl: 1.25, safe: 2,
      o: [[24,159.7],[23.9,160.8],[23.8,161.7],[23.7,162.9],[23.4,164.2],[23,165.7],[22.5,167.3],[21.8,169],[20.9,170.7],[19.8,172.4],[18.4,174.1],[16.9,175.7],[14.8,177.5],[12.8,178.9],[10.8,180.1],[8.8,181.1],[7,181.9],[5.3,182.5],[3.8,183],[2.5,183.3],[1.5,183.5],[0.7,183.6],[0,183.7],[0.2,28.9],[0.3,28.4],[0.4,27.2],[0.7,25.2],[1.3,22.8],[2.2,19.9],[3.6,16.8],[5.4,13.5],[7.7,10.2],[10.7,7.1],[14.4,4.3],[18.8,1.9],[24.1,0]] },
    { k: 'FE-16', t: 'feather-econo', shape: 'feather-econo', s: 'Econo', ft: '16 ft', w: 30.76, h: 137.75, sl: 1.25, safe: 2, d: 1,
      o: [[30.8,130.2],[0,137.8],[0,28],[0.1,25.9],[0.4,23.8],[0.8,21.7],[1.3,19.8],[1.9,17.9],[2.6,16.3],[3.2,14.8],[3.8,13.5],[4.4,12.4],[4.8,11.6],[5.5,10.3],[6.1,9.5],[6.7,8.4],[8.3,6],[9.9,3.5],[12.3,0],[30.8,0]] },
    { k: 'TD-S', t: 'teardrop', shape: 'teardrop', s: 'Small', ft: '7 ft', w: 23.17, h: 63.5, sl: 1.25, safe: 2,
      o: [[0.2,63.5],[0.2,62.9],[0.2,61.5],[0.1,49],[0,44.9],[0,40.5],[0,36],[0.1,31.6],[0.1,27.4],[0.3,23.4],[0.4,21.8],[0.6,20.1],[0.9,18.6],[1.2,17.1],[1.6,15.8],[2,14.5],[2.5,13.3],[2.9,12.2],[3.4,11.1],[4.2,9.4],[4.5,8.7],[5.3,7.4],[6.1,6.2],[7,5],[7.9,3.9],[9,2.9],[10,2],[11.1,1.2],[12.3,0.7],[13.4,0.2],[14.5,0],[15.7,0],[16.8,0.2],[18.4,0.9],[19.8,1.9],[20.7,3],[21.5,4.3],[21.9,5.6],[22.2,7],[22.3,8.2],[22.3,9.4],[22.3,10.4],[22.2,11.2],[22.1,11.9],[23.2,12.3]] },
    { k: 'TD-M', t: 'teardrop', shape: 'teardrop', s: 'Medium', ft: '9 ft', w: 32.53, h: 78.63, sl: 1.25, safe: 2, d: 1,
      o: [[0.9,78.6],[0.9,78.2],[0.9,76.9],[0.5,69.6],[0.4,66.2],[0.2,62.4],[0.1,58.2],[0,53.8],[0,49.3],[0,44.6],[0.2,39.9],[0.3,36.9],[0.4,34.3],[0.5,32.1],[0.7,30.1],[0.8,28.5],[1,27.1],[1.1,25.8],[1.3,24.7],[1.6,22.6],[2,20.6],[2.8,17.3],[4,14.2],[5.4,11.3],[7.1,8.6],[9,6.2],[11.1,4.2],[13.3,2.5],[15.6,1.2],[18,0.3],[20.4,0],[22.7,0.2],[25.1,1],[26.8,2.1],[28.3,3.4],[29.4,4.9],[30.2,6.4],[30.8,8],[31.2,9.6],[31.5,11.1],[31.6,12.4],[31.6,13.6],[31.6,14.5],[31.5,15.3],[32.5,15.8]] },
    { k: 'TD-L', t: 'teardrop', shape: 'teardrop', s: 'Large', ft: '11.2 ft', w: 40.37, h: 101.61, sl: 1.25, safe: 2,
      o: [[0.1,101.6],[0.1,101.6],[0.1,45.8],[0,40.4],[0,37.3],[0.2,34.4],[0.4,31.6],[0.8,28.9],[1.3,26.4],[1.8,23.9],[2.5,21.6],[3.2,19.3],[4,17.1],[4.9,15.1],[5.8,13],[7,10.7],[7.5,9.9],[8.4,8.6],[9.6,7],[11.2,5.4],[13.1,3.7],[15.3,2.2],[17.8,1],[20.7,0.2],[23.9,0],[27.4,0.5],[31.3,1.9],[32.1,2.2],[33,2.8],[34,3.5],[35.2,4.5],[36.4,5.8],[37.6,7.3],[38.5,9.2],[39.3,11.3],[39.7,13.8],[39.7,16.6],[39.3,19.8],[40.4,20.3]] },
    { k: 'TD-XL', t: 'teardrop', shape: 'teardrop', s: 'XL', ft: '13.5 ft', w: 44.95, h: 140.74, sl: 1.25, safe: 2,
      o: [[0.2,140.7],[0.2,135.2],[0,102.5],[0.2,48.8],[0.2,46],[0.4,43.1],[0.7,40.1],[1.1,37.1],[1.6,34.1],[2.2,31.1],[3,28.2],[3.8,25.3],[4.7,22.6],[5.8,20],[6.9,17.6],[8.1,15.3],[8.9,14.1],[10,12.6],[11.3,11],[12.8,9.3],[14.5,7.6],[16.4,5.9],[18.4,4.3],[20.4,2.9],[22.6,1.7],[24.9,0.7],[27.1,0.2],[29.4,0],[31.6,0.2],[33.5,0.5],[35.3,1],[36.9,1.6],[38.3,2.3],[39.6,3.2],[40.6,4.1],[41.5,5.1],[42.3,6.1],[43,7.2],[43.5,8.2],[43.8,9.2],[44.2,10.5],[44.5,11.8],[44.7,13],[44.8,14.3],[44.9,15.6],[44.9,16.9],[44.9,18.1],[44.7,19.4],[44.5,20.6],[44.2,21.9],[43.9,23.1],[43.5,24.2],[43.2,25],[45,25.6]] },
    { k: 'TD-DESK', t: 'teardrop', shape: 'teardrop-desk', s: 'Desktop', ft: '', w: 10, h: 19.76, sl: 0.5, safe: 1,
      o: [[1,19.8],[0.5,19.6],[0.3,17.8],[0.1,15.5],[0,13.7],[0,11.9],[0,11],[0,10.2],[0.1,9.4],[0.2,8.1],[0.3,7.5],[0.5,6.5],[0.7,5.5],[0.9,4.8],[1,4.4],[1.2,4],[1.3,3.6],[1.5,3.2],[1.8,2.9],[2,2.5],[2.3,2.1],[2.6,1.7],[2.9,1.4],[3.2,1.1],[3.6,0.8],[4.1,0.5],[4.5,0.3],[4.9,0.2],[5.5,0.1],[5.8,0],[6.1,0],[6.5,0],[6.9,0.1],[7.3,0.2],[7.6,0.3],[7.8,0.5],[8.1,0.6],[8.3,0.8],[8.6,1.1],[8.8,1.3],[9,1.6],[9.2,1.9],[9.3,2.2],[9.5,2.5],[9.6,2.8],[9.7,3.4],[9.7,3.9],[9.7,4.3],[9.7,4.7],[9.5,6],[10,6.2]] },
    { k: 'RC-S', t: 'rectangle', shape: 'rectangle', s: 'Small', ft: '8.5 ft', w: 31, h: 90.58, sl: 1.25, safe: 2,
      o: [[31,90.6],[0,90.5],[0,5],[5,0],[31,0]] },
    { k: 'RC-M', t: 'rectangle', shape: 'rectangle', s: 'Medium', ft: '11.8 ft', w: 31, h: 114.17, sl: 1.25, safe: 2, d: 1,
      o: [[31,114.2],[0,114.1],[0,5],[5,0],[31,0]] },
    { k: 'RC-L', t: 'rectangle', shape: 'rectangle', s: 'Large', ft: '15 ft', w: 31, h: 151.56, sl: 1.25, safe: 2,
      o: [[31,151.6],[0,151.6],[0,5],[5,0],[31,0]] },
    { k: 'PF-3x2', t: 'pole-flag', shape: 'pole-flag', s: '3 x 2 ft', ft: '', w: 36, h: 24, sl: 1.25, safe: 2 },
    { k: 'PF-5x3', t: 'pole-flag', shape: 'pole-flag', s: '5 x 3 ft', ft: '', w: 60, h: 36, sl: 1.25, safe: 2, d: 1 },
    { k: 'PF-6x4', t: 'pole-flag', shape: 'pole-flag', s: '6 x 4 ft', ft: '', w: 72, h: 48, sl: 1.25, safe: 2 }
  ];
  const DEFAULT_FLAG = 'FA-L';
  const flagOf = (k) => FLAGS.find((f) => f.k === k) || null;
  const typeOf = (fl) => FLAG_TYPES[fl.t] || FLAG_TYPES.rectangle;
  const sizeText = (fl) => fl.s + (fl.ft ? ' ' + fl.ft : '');
  const flagLabel = (k) => { const fl = flagOf(k) || flagOf(DEFAULT_FLAG); return `${typeOf(fl).label} · ${sizeText(fl)}`; };
  const flagShort = (k) => { const fl = flagOf(k) || flagOf(DEFAULT_FLAG); return `${sizeText(fl)} ${typeOf(fl).short}`; };
  // What the worker is asked for (feet): the whole printed graphic. "up" = landscape design (width = flag height),
  // turned 90 degrees counter-clockwise on the flag.
  function reqOf(fl, dir) {
    const fw = fl.w / 12;
    const fh = fl.h / 12;
    if (dir === 'up' && typeOf(fl).dirs) return { w: round2(fh), h: round2(fw), rot: -90, dir: 'up' };
    return { w: round2(fw), h: round2(fh), rot: 0, dir: 'across' };
  }
  const frameAr = (k) => { const fl = flagOf(k); return fl && fl.w > fl.h ? 1.5 : 1.4; };
  // the flag's filled ends, as seen on the flag (wideImg: the design is extended left/right in its own orientation)
  const endsWhere = (b, wideImg) => ((b && b.rot ? !wideImg : wideImg) ? 'left and right' : 'top and bottom');

  // flag outline in inches (x right, y down, pole on the left)
  function bez(p0, p1, p2, p3, out) {
    for (let i = 1; i <= 16; i++) {
      const t = i / 16, u = 1 - t, a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
      out.push([a * p0[0] + b * p1[0] + c * p2[0] + d * p3[0], a * p0[1] + b * p1[1] + c * p2[1] + d * p3[1]]);
    }
  }
  // drawn outline (0..1 of the box) for a flag without a measured outline
  function unitShape(shape) {
    const P = [];
    if (/^feather-angled/.test(shape)) { P.push([0, 1], [0, 0.36]); bez([0, 0.36], [0, 0.12], [0.45, 0], [1, 0], P); P.push([1, 0.88]); }
    else if (/^feather-econo/.test(shape)) { P.push([0, 1], [0, 0.21]); bez([0, 0.21], [0, 0.08], [0.2, 0], [0.42, 0], P); P.push([1, 0], [1, 0.95]); }
    else if (/^feather/.test(shape)) { P.push([0, 1], [0, 0.36]); bez([0, 0.36], [0, 0.12], [0.45, 0], [1, 0], P); P.push([1, 0.73]); bez([1, 0.73], [1, 0.9], [0.5, 1], [0, 1], P); }
    else if (/^teardrop/.test(shape)) { P.push([0.03, 1], [0, 0.6]); bez([0, 0.6], [0, 0.1], [0.4, 0], [0.62, 0], P); bez([0.62, 0], [0.9, 0], [1, 0.12], [1, 0.2], P); }
    else if (shape === 'rectangle') P.push([0, 1], [0, 0.05], [0.16, 0], [1, 0], [1, 1]);
    else P.push([0, 0], [1, 0], [1, 1], [0, 1]);
    return P;
  }
  // The sleeve (and the pole inside it) runs up the pole edge from the bottom corner, then along the top: to the top
  // outer corner on feather and rectangle flags, around the curved corner only on the econo flag, over the top and
  // down to the notch on teardrops, and only up the pole edge on pole flags. y0 = top of the straight pole edge.
  function sleeveOf(fl, g) {
    const P = g.pts, n = P.length, lim = Math.max(1.1, g.W * 0.04);
    let i0 = -1;
    P.forEach((p, i) => { if (p[0] <= lim && (i0 < 0 || p[1] > P[i0][1])) i0 = i; });
    if (i0 < 0) i0 = 0;
    const nx = P[(i0 + 1) % n], pv = P[(i0 - 1 + n) % n];
    const dir = nx[0] <= lim && (pv[0] > lim || nx[1] <= pv[1]) ? 1 : -1;
    const minY = Math.min(...P.map((p) => p[1]));
    const topX = Math.max(...P.filter((p) => p[1] <= minY + 0.5).map((p) => p[0]));
    const path = [P[i0]];
    for (let s = 1; s < n; s++) {
      const p = P[(i0 + dir * s + n * 2) % n];
      path.push(p);
      if (fl.t === 'pole-flag' && p[1] <= minY + 0.01) break;
      if (fl.t === 'feather-econo' && p[1] <= minY + 0.5) break;
      if ((fl.t === 'feather-angled' || fl.t === 'feather-convex' || fl.t === 'rectangle') && p[1] <= minY + 0.5 && p[0] >= topX - 0.01) break;
    }
    const edge = path.filter((p) => p[0] <= lim).map((p) => p[1]);
    return { y0: edge.length ? Math.min(...edge) : 0, path };
  }
  const GEO = {};
  function geoOf(fl) {
    if (GEO[fl.k]) return GEO[fl.k];
    let W = fl.w, H = fl.h, pts;
    if (Array.isArray(fl.o) && fl.o.length > 2) {
      const xs = fl.o.map((p) => p[0]), ys = fl.o.map((p) => p[1]);
      const x0 = Math.min(...xs), y0 = Math.min(...ys);
      W = Math.max(...xs) - x0;
      H = Math.max(...ys) - y0;
      pts = fl.o.map((p) => [p[0] - x0, p[1] - y0]);
    } else pts = unitShape(fl.shape).map((p) => [p[0] * W, p[1] * H]);
    const sl = fl.sl || 1.25;
    const g = { W, H, sl, pts, pw: Math.max(W * 0.02, sl * 0.55, 0.5), padX: Math.max(sl * 1.8, W * 0.07), padT: Math.max(H * 0.03, sl * 1.5), padB: H * (W > H ? 0.3 : 0.12) };
    g.sleeve = sleeveOf(fl, g);
    GEO[fl.k] = g;
    return g;
  }
  function tracePath(x, pts, close) { x.beginPath(); pts.forEach((p, i) => (i ? x.lineTo(p[0], p[1]) : x.moveTo(p[0], p[1]))); if (close) x.closePath(); }
  // Draws the flag on its pole with the design placed the way the flag designer places it: turned by rot, fitted to
  // the printed graphic, plain ends filled from the design's own edges (composeEnds), clipped to the cut outline,
  // with the black sleeve outside the print. hPx = canvas height in pixels.
  function drawFlag(cv, img, key, rot, smooth, hPx) {
    const fl = flagOf(key) || flagOf(DEFAULT_FLAG);
    const g = geoOf(fl);
    const k = hPx / (g.H + g.padT + g.padB);
    cv.width = Math.max(2, Math.round((g.W + g.padX * 2) * k));
    cv.height = Math.max(2, Math.round(hPx));
    const x = cv.getContext('2d');
    x.setTransform(k, 0, 0, k, g.padX * k, g.padT * k);
    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    x.fillStyle = '#9aa1ab';
    x.fillRect(-g.sl / 2 - g.pw / 2, g.sleeve.y0, g.pw, g.H - g.sleeve.y0 + g.padB * 0.92);
    tracePath(x, g.sleeve.path, false);
    x.lineWidth = g.sl * 2;
    x.lineJoin = 'round';
    x.lineCap = 'round';
    x.strokeStyle = '#3d3d47';
    x.stroke();
    x.save();
    tracePath(x, g.pts, true);
    x.clip();
    x.fillStyle = '#f4f4f6';
    x.fillRect(0, 0, g.W, g.H);
    if (img) {
      if (rot) {
        const art = composeEnds(img, g.H / g.W, smooth, Math.max(48, Math.round(g.W * k)));
        x.save();
        x.translate(0, g.H);
        x.rotate(-Math.PI / 2);
        x.drawImage(art, 0, 0, g.H, g.W);
        x.restore();
      } else {
        const art = composeEnds(img, g.W / g.H, smooth, Math.max(48, Math.round(Math.min(g.W, g.H) * k)));
        x.drawImage(art, 0, 0, g.W, g.H);
      }
    }
    x.restore();
    tracePath(x, g.pts, true);
    x.lineWidth = 1.5 / k;
    x.strokeStyle = 'rgba(255,255,255,.7)';
    x.stroke();
    return cv;
  }
  function flagPic(img, b, smooth, hPx) {
    const cv = document.createElement('canvas');
    cv.className = 'afl__cv';
    return drawFlag(cv, img, b.flag, b.rot, smooth, hPx);
  }
  const r1 = (n) => Math.round(n * 10) / 10;
  // the small flag picture in step 1 (outline, sleeve, pole and which way the words run)
  function shapeSvg(fl, dir) {
    const g = geoOf(fl);
    const d = 'M' + g.pts.map((p) => `${r1(p[0])} ${r1(p[1])}`).join('L') + 'Z';
    const sleeve = 'M' + g.sleeve.path.map((p) => `${r1(p[0])} ${r1(p[1])}`).join('L');
    const cx = g.W / 2, cy = g.H / 2;
    let words;
    if (dir === 'up' && typeOf(fl).dirs) {
      const fs = Math.min(g.W * 0.45, g.H / 6.5);
      words = `<text class="afl__shape-txt" x="0" y="0" font-size="${r1(fs)}" text-anchor="middle" dominant-baseline="central" transform="translate(${r1(cx)} ${r1(cy)}) rotate(-90)">YOUR WORDS</text>`;
    } else {
      const fs = Math.min(g.W / 5.4, g.H / 4.5);
      words = ['YOUR', 'WORDS'].map((t, i) => `<text class="afl__shape-txt" x="${r1(cx)}" y="${r1(cy + (i ? 0.6 : -0.6) * fs)}" font-size="${r1(fs)}" text-anchor="middle" dominant-baseline="central">${t}</text>`).join('');
    }
    return `<svg viewBox="${r1(-g.padX)} ${r1(-g.padT)} ${r1(g.W + g.padX * 2)} ${r1(g.H + g.padT + g.padB)}" focusable="false" aria-hidden="true">` +
      `<defs><clipPath id="afl-clip"><path d="${d}"/></clipPath></defs>` +
      `<rect x="${r1(-g.sl / 2 - g.pw / 2)}" y="${r1(g.sleeve.y0)}" width="${r1(g.pw)}" height="${r1(g.H - g.sleeve.y0 + g.padB * 0.92)}" rx="${r1(g.pw / 2)}" fill="#9aa1ab"/>` +
      `<path d="${sleeve}" class="afl__shape-sleeve" stroke-width="${r1(g.sl * 2)}"/>` +
      `<path d="${d}" class="afl__shape-face"/>` +
      `<g clip-path="url(#afl-clip)">${words}</g>` +
      `<path d="${d}" class="afl__shape-line"/></svg>`;
  }

  function showErr(msg, el = errEl) { el.textContent = msg || ''; el.hidden = !msg; }
  function setInvalid(el, bad) { if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
  function withEmail(body) { if (S.hasEmail && email) body.email = email; return body; }

  function setQuota() {
    if (S.bannersLeft == null) return;
    const n = S.bannersLeft;
    const s = n === 1 ? '' : 's';
    if (S.hasEmail) quotaEl.textContent = n > 0 ? `${n} tr${n === 1 ? 'y' : 'ies'} left today` : 'No tries left today';
    else quotaEl.textContent = n > 0 ? `${n} free tr${n === 1 ? 'y' : 'ies'} · 4 designs each · no sign-up` : `Add your email for ${S.emailBanners} tries a day`;
    if (gateN) gateN.textContent = String(S.emailBanners);
    $$('.abi__fix-left', grid).forEach((el) => { el.textContent = fixesText(); });
  }
  function fixesText() {
    if (S.fixesLeft == null) return '';
    return `${S.fixesLeft} fix${S.fixesLeft === 1 ? '' : 'es'} left today`;
  }

  /* ---------- API ---------- */
  async function api(path, body, timeoutMs = 180000) {
    const opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    let timer = 0;
    if (window.AbortController) {
      const ctl = new AbortController();
      opts.signal = ctl.signal;
      timer = setTimeout(() => ctl.abort(), timeoutMs);
    }
    let r;
    try {
      r = await fetch(API + path, opts);
    } catch (e) {
      clearTimeout(timer);
      if (e && e.name === 'AbortError') return { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' };
      return { ok: false, error: 'network', message: 'Check your connection and try again.' };
    }
    let j = {};
    try { j = await r.json(); } catch (e) { j = {}; }
    clearTimeout(timer);
    if (!j || typeof j !== 'object') j = {};
    if (r.status === 402 && !j.error) j.error = 'need_email';
    if (!r.ok) {
      if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' };
      j.ok = false;
    }
    return j;
  }

  /* ---------- Turnstile (same approach as the sticker generator: explicit render, invisible, fresh token per POST) ---------- */
  let tsReady = null;
  let tsWidget = null;
  let tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise((res) => {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.abiTurnstileLoaded = () => res(true);
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=abiTurnstileLoaded';
      s.async = true;
      s.defer = true;
      s.onerror = () => res(false);
      document.head.appendChild(s);
    });
    return tsReady;
  }
  async function botToken() {
    if (!SITEKEY || !(await loadTurnstile()) || !window.turnstile) return '';
    return new Promise((res) => {
      tsResolve = res;
      const take = (t) => { const r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
      try {
        if (tsWidget === null) {
          tsWidget = window.turnstile.render($('[data-abi-turnstile]'), {
            sitekey: SITEKEY,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: (t) => take(t),
            'error-callback': () => take('')
          });
        } else {
          window.turnstile.reset(tsWidget);
        }
        window.turnstile.execute(tsWidget);
      } catch (e) { take(''); }
      setTimeout(() => { if (tsResolve === res) take(''); }, 45000);
    });
  }

  /* ---------- flag: shape, size and which way the words run ---------- */
  const NOTES = {
    up: 'The words run up the flag and read from the bottom, like most feather flags. We design it sideways, turn it, and stretch the plain ends to fill the top and bottom.',
    across: 'Words across a narrow flag print small, so keep them to one or two short words. We design the middle and stretch the plain top and bottom to fill the flag.',
    teardrop: 'Designed in your flag\'s shape. The round top and the point are trimmed to the outline, so we keep the words near the middle.',
    pole: 'Designed in your flag\'s shape. The strip on the pole side holds the pole, so we keep words off it.'
  };
  function buildSizes(type) {
    sizeRow.innerHTML = '';
    FLAGS.filter((f) => f.t === type).forEach((f) => {
      const c = document.createElement('button');
      c.type = 'button';
      c.className = 'abi__chip';
      c.dataset.flag = f.k;
      c.setAttribute('aria-pressed', 'false');
      c.textContent = f.s;
      if (f.ft) { const sm = document.createElement('small'); sm.textContent = f.ft; c.append(' ', sm); }
      c.addEventListener('click', () => setFlag(f.k));
      sizeRow.appendChild(c);
    });
    sizeRow.dataset.type = type;
  }
  function setFlag(key, dir) {
    const fl = flagOf(key) || flagOf(DEFAULT_FLAG);
    const T = typeOf(fl);
    if (dir === 'up' || dir === 'across') S.pref = dir;
    if (sizeRow.dataset.type !== fl.t) buildSizes(fl.t);
    const r = reqOf(fl, S.pref);
    S.flag = fl.k;
    S.dir = r.dir;
    S.rot = r.rot;
    S.w = r.w;
    S.h = r.h;
    typeChips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.type === fl.t)));
    $$('.abi__chip', sizeRow).forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.flag === fl.k)));
    dirRow.hidden = !T.dirs;
    dirChips.forEach((c) => c.setAttribute('aria-pressed', String(c.dataset.dir === S.dir)));
    try { shapeBox.innerHTML = shapeSvg(fl, S.dir); } catch (e) { shapeBox.innerHTML = ''; }
    shapeLabel.textContent = flagShort(fl.k) + (T.dirs ? (S.dir === 'up' ? ' · words run up' : ' · words across') : '');
    sizeNote.textContent = T.dirs ? NOTES[S.dir] : (fl.t === 'teardrop' ? NOTES.teardrop : NOTES.pole);
    showErr('', sizeErr);
  }
  typeChips.forEach((c) => c.addEventListener('click', () => {
    const cur = flagOf(S.flag);
    if (cur && cur.t === c.dataset.type) return;
    const list = FLAGS.filter((f) => f.t === c.dataset.type);
    if (!list.length) return;
    const same = cur && list.find((f) => f.s === cur.s);
    setFlag((same || list.find((f) => f.d) || list[0]).k);
  }));
  dirChips.forEach((c) => c.addEventListener('click', () => setFlag(S.flag, c.dataset.dir)));

  /* ---------- logo: any image -> PNG (max 1536 px long side) in the browser ---------- */
  const LOGO_TYPES = /^image\/(png|jpeg|jpg|pjpeg|webp|svg\+xml|gif)$/i;
  const LOGO_EXT = /\.(png|jpe?g|webp|svg|gif)$/i;
  function loadImg(src) {
    return new Promise((res, rej) => {
      const im = new Image();
      im.decoding = 'async';
      im.onload = () => res(im);
      im.onerror = () => rej(new Error('image'));
      im.src = src;
    });
  }
  function canvasBlob(img, w, h, type = 'image/png') {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    const ctx = c.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, w, h);
    return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob'))), type));
  }
  function thumbData(img, w, h) {
    const s = Math.min(1, 160 / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    try { return c.toDataURL('image/png'); } catch (e) { return ''; }
  }
  async function svgSource(file) {
    const txt = await file.text();
    const doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
    const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.getElementsByTagName('parsererror').length) throw new Error('svg');
    const dim = (a) => { const v = svg.getAttribute(a) || ''; return /%/.test(v) ? NaN : parseFloat(v); };
    let vw = dim('width');
    let vh = dim('height');
    const vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
    if (hasVb && !(vw > 0 && vh > 0)) { vw = vb[2]; vh = vb[3]; }
    if (!(vw > 0 && vh > 0)) { vw = 1024; vh = 1024; }
    if (!hasVb) svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    const s = MAX_LOGO_PX / Math.max(vw, vh); // vector: always render at the full 1536 px long side
    const w = Math.max(1, Math.round(vw * s));
    const h = Math.max(1, Math.round(vh * s));
    svg.setAttribute('width', String(w));
    svg.setAttribute('height', String(h));
    const src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    return { src, w, h };
  }
  async function toPng(file) {
    const isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    let src;
    let w;
    let h;
    if (isSvg) ({ src, w, h } = await svgSource(file));
    else src = URL.createObjectURL(file);
    try {
      const img = await loadImg(src);
      if (!isSvg) {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) throw new Error('size');
        const s = Math.min(1, MAX_LOGO_PX / Math.max(nw, nh));
        w = Math.max(1, Math.round(nw * s));
        h = Math.max(1, Math.round(nh * s));
      }
      let blob = await canvasBlob(img, w, h);
      for (let i = 0; i < 4 && blob.size > MAX_LOGO_BYTES; i++) {
        w = Math.max(1, Math.round(w * 0.75));
        h = Math.max(1, Math.round(h * 0.75));
        blob = await canvasBlob(img, w, h);
      }
      if (blob.size > MAX_LOGO_BYTES) throw new Error('big');
      return { blob, w, h, thumbData: thumbData(img, w, h) };
    } finally {
      URL.revokeObjectURL(src);
    }
  }
  function setLogo(L) {
    if (S.logo && S.logo.thumb && S.logo.thumb.indexOf('blob:') === 0) URL.revokeObjectURL(S.logo.thumb);
    S.logo = L;
    if (L) {
      logoImg.src = L.thumb || L.thumbData || '';
      logoName.textContent = L.name || 'Your logo';
      logoInfo.textContent = 'Added to every design';
    }
    logoRow.hidden = !L;
    drop.hidden = !!L;
  }
  async function takeLogo(file) {
    showErr('', logoErr);
    if (!(LOGO_TYPES.test(file.type || '') || LOGO_EXT.test(file.name || ''))) { showErr('Please choose a PNG, JPG, SVG, WEBP or GIF file.', logoErr); return; }
    if (file.size > MAX_SOURCE_BYTES) { showErr('That file is too big. Please use one under 30 MB.', logoErr); return; }
    drop.classList.add('is-busy');
    try {
      const out = await toPng(file);
      setLogo({ blob: out.blob, w: out.w, h: out.h, name: file.name, id: null, thumb: URL.createObjectURL(out.blob), thumbData: out.thumbData });
      track('ardor_flag_ai_logo', {});
    } catch (e) {
      showErr("We couldn't read that file. Try saving your logo as a PNG or JPG.", logoErr);
    }
    drop.classList.remove('is-busy');
  }
  fileIn.addEventListener('change', () => {
    const f = fileIn.files && fileIn.files[0];
    if (f) takeLogo(f);
    fileIn.value = '';
  });
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, () => drop.classList.add('is-over')));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, () => drop.classList.remove('is-over')));
  $('[data-abi-logo-remove]').addEventListener('click', () => {
    setLogo(null);
    showErr('', logoErr);
    fileIn.focus();
  });
  async function uploadLogo() {
    const L = S.logo;
    if (!L) return '';
    if (L.id) return L.id;
    if (!L.blob) throw { message: 'Please add your logo again.' };
    const fd = new FormData();
    fd.append('file', L.blob, 'logo.png');
    fd.append('visitor', visitor);
    const j = await api('/api/banner/logo', fd, 60000);
    if (!j.ok || !j.logoId) throw j;
    L.id = j.logoId;
    return j.logoId;
  }

  /* ---------- wording + style ---------- */
  function syncCount(key, el) {
    const c = $(`[data-abi-count="${key}"]`);
    if (!c) return;
    const n = el.value.length;
    c.textContent = `${n}/${LIMITS[key]}`;
    c.classList.toggle('is-near', n >= LIMITS[key] - 5);
  }
  Object.keys(lineIns).forEach((k) => {
    lineIns[k].addEventListener('input', () => {
      syncCount(k, lineIns[k]);
      if (k === 'headline' && clean(lineIns[k].value)) { setInvalid(lineIns[k], false); showErr('', headErr); }
      showErr('');
    });
  });
  notesIn.addEventListener('input', () => syncCount('notes', notesIn));

  function setStyle(st) {
    S.style = STYLES[st] ? st : 'bold';
    styleBtns.forEach((b) => {
      const on = b.dataset.style === S.style;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
  }
  styleBtns.forEach((b) => {
    b.addEventListener('click', () => setStyle(b.dataset.style));
    b.addEventListener('keydown', (e) => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const i = styleBtns.indexOf(b);
      const n = styleBtns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + styleBtns.length) % styleBtns.length];
      setStyle(n.dataset.style);
      n.focus();
    });
  });

  function readForm(show) {
    const fl = flagOf(S.flag);
    let first = null;
    if (!fl || !validFt(S.w) || !validFt(S.h)) {
      if (show) showErr('Pick your flag shape and size.', sizeErr);
      first = typeChips[0] || null;
    }
    const headline = clean(lineIns.headline.value).slice(0, LIMITS.headline);
    setInvalid(lineIns.headline, !headline);
    if (!headline) {
      if (show) showErr('Type the main words for your flag.', headErr);
      first = first || lineIns.headline;
    }
    if (first) {
      if (show) { first.focus({ preventScroll: true }); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return null;
    }
    const lines = { headline };
    const sub = clean(lineIns.subline.value).slice(0, LIMITS.subline);
    const det = clean(lineIns.details.value).slice(0, LIMITS.details);
    if (sub) lines.subline = sub;
    if (det) lines.details = det;
    return { w: S.w, h: S.h, flag: S.flag, dir: S.dir, rot: S.rot, style: S.style, notes: clean(notesIn.value).slice(0, LIMITS.notes), lines, hasLogo: !!S.logo };
  }

  /* ---------- busy states ---------- */
  function setBusyUi(on) {
    goBtn.disabled = on || S.off;
    goLabel.textContent = on ? 'Designing…' : 'Design my flag';
    againBtn.disabled = on;
    editBtn.disabled = on;
    $$('button, input', grid).forEach((el) => { el.disabled = on; });
  }
  let genTimer = 0;
  function placeholder(ar) {
    const c = document.createElement('div');
    c.className = 'abi__card is-loading';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = `<div class="abi__frame" style="--ar:${ar}"><span class="abi__skel" style="--art:${clampAr(ar)}"><i></i><i></i><i></i></span></div><div class="abi__card-actions"><span class="abi__skel-btn"></span><span class="abi__skel-btn"></span></div>`;
    return c;
  }
  function startGenLoading(v) {
    S.busy = true;
    setBusyUi(true);
    results.hidden = false;
    loading.hidden = false;
    againRow.hidden = true;
    fineEl.hidden = true;
    echo.textContent = v.lines.headline;
    metaEl.textContent = `${flagLabel(v.flag)} · ${STYLES[v.style]}`;
    const ar = frameAr(v.flag);
    grid.dataset.shape = 'flag';
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (let i = 0; i < 4; i++) grid.appendChild(placeholder(ar));
    const steps = GEN_STEPS.filter((m) => !m[3] || (m[3] === 'logo' && v.hasLogo));
    const t0 = Date.now();
    let last = -1;
    const tick = () => {
      const t = (Date.now() - t0) / 1000;
      bar.style.width = `${Math.min(95, 100 * (1 - Math.exp(-t / 36)))}%`;
      let k = 0;
      steps.forEach((m, i) => { if (t >= m[0]) k = i; });
      if (k === last) return;
      last = k;
      statusEl.textContent = steps[k][1];
      stepEls.forEach((li, i) => {
        li.classList.toggle('is-done', i < steps[k][2]);
        li.classList.toggle('is-on', i === steps[k][2]);
      });
    };
    clearInterval(genTimer);
    tick();
    genTimer = setInterval(tick, 250);
  }
  function stopGenLoading() {
    clearInterval(genTimer);
    S.busy = false;
    setBusyUi(false);
    loading.hidden = true;
    bar.style.width = '0';
    againRow.hidden = false;
    fineEl.hidden = false;
    grid.removeAttribute('aria-busy');
  }
  function cardBusy(card, title, sub, slow) {
    const o = $('.abi__busy', card);
    const fill = $('.abi__busy-bar i', card);
    $('.abi__busy-t', card).textContent = title;
    $('.abi__busy-s', card).textContent = sub;
    o.hidden = false;
    card.classList.add('is-busy');
    const t0 = Date.now();
    const tm = setInterval(() => { fill.style.width = `${Math.min(95, 100 * (1 - Math.exp(-(Date.now() - t0) / 1000 / slow)))}%`; }, 250);
    return () => { clearInterval(tm); o.hidden = true; card.classList.remove('is-busy'); fill.style.width = '0'; };
  }
  function cardErr(card, msg) { const el = card && $('.abi__cerr', card); if (el) showErr(msg, el); }
  const findCard = (id) => grid.querySelector(`.abi__card[data-id="${window.CSS && CSS.escape ? CSS.escape(id) : id}"]`);

  /* ---------- busy edges (same check as the banner builder, ardor-banner-layers.js) ---------- */
  const EDGE_BUSY = 2.5;
  // How streaky a design's stretched ends will look. Looks at the outer 2% of each edge that gets stretched,
  // sampled about 96 steps along the edge, and measures change in both directions: plain colors, smooth
  // gradients and stripes that already run straight off the edge score near 0; photos, busy textures and
  // text or shapes cut by the edge score high. Returns { a, b, score, busy } (a = left/top, b = right/bottom).
  function edgeBusy(img, wide) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return null;
    var L = wide ? ih : iw, st = Math.max(1, L / 96);
    var n = Math.max(16, Math.round(L / st)), d = Math.max(4, Math.round((wide ? iw : ih) * 0.02 / st)), depth = d * st;
    var cw = wide ? d : n, ch = wide ? n : d, res = [];
    for (var s = 0; s < 2; s++) {
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      if (wide) x.drawImage(img, s ? iw - depth : 0, 0, depth, ih, 0, 0, cw, ch);
      else x.drawImage(img, 0, s ? ih - depth : 0, iw, depth, 0, 0, cw, ch);
      var p = x.getImageData(0, 0, cw, ch).data;
      // per block along the edge (8 blocks): mean change along the edge and across it, max over R, G, B
      var B = 8, al = new Float64Array(B), ac = new Float64Array(B), na = new Float64Array(B), nc = new Float64Array(B);
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var i = (yy * cw + xx) * 4, along = wide ? yy : xx, blk = Math.min(B - 1, Math.floor(along * B / n));
        if (xx + 1 < cw) {
          var dx = Math.max(Math.abs(p[i] - p[i + 4]), Math.abs(p[i + 1] - p[i + 5]), Math.abs(p[i + 2] - p[i + 6]));
          if (wide) { ac[blk] += dx; nc[blk]++; } else { al[blk] += dx; na[blk]++; }
        }
        if (yy + 1 < ch) {
          var j = i + cw * 4, dy = Math.max(Math.abs(p[i] - p[j]), Math.abs(p[i + 1] - p[j + 1]), Math.abs(p[i + 2] - p[j + 2]));
          if (wide) { al[blk] += dy; na[blk]++; } else { ac[blk] += dy; nc[blk]++; }
        }
      }
      var sum = 0, top = 0;
      for (var k = 0; k < B; k++) {
        var v = Math.sqrt((na[k] ? al[k] / na[k] : 0) * (nc[k] ? ac[k] / nc[k] : 0));
        sum += v; if (v > top) top = v;
      }
      res.push(Math.max(sum / B, top * 0.5));
    }
    var score = Math.max(res[0], res[1]);
    return { a: res[0], b: res[1], score: score, busy: score > EDGE_BUSY };
  }


  /* ---------- end previews (same drawing as the banner builder's extend(), ardor-banner-layers.js) ---------- */
  // Draws the design at the banner's real shape with its ends filled, stretched (as the builder does by default)
  // or smooth (&ends=smooth), so the customer can pick before the print version is made. size = preview short side.
  function mkC(w, h) { const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function composeEnds(img, B, smooth, size) {
    const wide = B > 1, nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height;
    const k = Math.min(1, size / (wide ? nh : nw));
    const src = mkC(nw * k, nh * k), sx0 = src.getContext('2d');
    sx0.imageSmoothingEnabled = true; sx0.imageSmoothingQuality = 'high'; sx0.drawImage(img, 0, 0, src.width, src.height);
    const iw0 = src.width, ih0 = src.height;
    let cw, ch;
    if (wide) { ch = ih0; cw = Math.round(ih0 * B); } else { cw = iw0; ch = Math.round(iw0 / B); }
    const iw = wide ? Math.round(iw0 * ch / ih0) : cw, ih = wide ? ch : Math.round(ih0 * cw / iw0);
    const ox = wide ? Math.round((cw - iw) / 2) : 0, oy = wide ? 0 : Math.round((ch - ih) / 2);
    const cv = mkC(cw, ch), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    const A = wide ? ['l', 0, 0, ox, ch, 'r', ox + iw, 0, cw - ox - iw, ch] : ['t', 0, 0, cw, oy, 'b', 0, oy + ih, cw, ch - oy - ih];
    for (let q = 0; q < 10; q += 5) (smooth ? soften : side)(x, src, iw0, ih0, A[q], A[q + 1], A[q + 2], A[q + 3], A[q + 4]);
    x.drawImage(src, ox, oy, iw, ih);
    if (smooth) {
      const f = Math.max(2, Math.round((wide ? iw : ih) * 0.05));
      if (wide) { soften(x, src, iw0, ih0, 'l', ox, 0, f, ch, 1); soften(x, src, iw0, ih0, 'r', ox + iw - f, 0, f, ch, 1); }
      else { soften(x, src, iw0, ih0, 't', 0, oy, cw, f, 1); soften(x, src, iw0, ih0, 'b', 0, oy + ih - f, cw, f, 1); }
    }
    return cv;
  }
  // soft fill for one side: the outer 6% of the design averaged into 6 steps along the edge, then
  // stretched smoothly over the side. feather = 1 draws it over the design's own edge, fading out inward.
  function soften(x, img, iw0, ih0, where, dx, dy, dw, dh, feather) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', band = Math.max(1, Math.round((horiz ? iw0 : ih0) * 0.06));
    var mid = horiz ? mkC(1, 64) : mkC(64, 1), mx = mid.getContext('2d');
    mx.imageSmoothingEnabled = true; mx.imageSmoothingQuality = 'high';
    if (where === 'l') mx.drawImage(img, 0, 0, band, ih0, 0, 0, 1, 64);
    if (where === 'r') mx.drawImage(img, iw0 - band, 0, band, ih0, 0, 0, 1, 64);
    if (where === 't') mx.drawImage(img, 0, 0, iw0, band, 0, 0, 64, 1);
    if (where === 'b') mx.drawImage(img, 0, ih0 - band, iw0, band, 0, 0, 64, 1);
    var small = horiz ? mkC(1, 6) : mkC(6, 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(mid, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    if (feather) {
      var g = where === 'l' ? so.createLinearGradient(0, 0, dw, 0) : where === 'r' ? so.createLinearGradient(dw, 0, 0, 0)
        : where === 't' ? so.createLinearGradient(0, 0, 0, dh) : so.createLinearGradient(0, dh, 0, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    }
    x.drawImage(soft, dx, dy);
  }
  function side(x, img, iw0, ih0, where, dx, dy, dw, dh) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', n = Math.max(1, Math.min(4, horiz ? iw0 : ih0));
    var line = horiz ? mkC(1, dh) : mkC(dw, 1), lx = line.getContext('2d');
    lx.imageSmoothingEnabled = true; lx.imageSmoothingQuality = 'high';
    if (where === 'l') lx.drawImage(img, 0, 0, n, ih0, 0, 0, 1, dh);
    if (where === 'r') lx.drawImage(img, iw0 - n, 0, n, ih0, 0, 0, 1, dh);
    if (where === 't') lx.drawImage(img, 0, 0, iw0, n, 0, 0, dw, 1);
    if (where === 'b') lx.drawImage(img, 0, ih0 - n, iw0, n, 0, 0, dw, 1);
    var sharp = mkC(dw, dh), sx = sharp.getContext('2d');
    sx.imageSmoothingEnabled = false;
    sx.drawImage(line, 0, 0, dw, dh);
    var len = horiz ? dh : dw, k = Math.max(2, Math.round(len / 40));
    var small = horiz ? mkC(1, Math.max(2, Math.round(dh / k))) : mkC(Math.max(2, Math.round(dw / k)), 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(line, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    var fade = Math.max(1, Math.min(horiz ? dw : dh, len * 0.3)), g;
    if (where === 'l') g = so.createLinearGradient(dw, 0, dw - fade, 0);
    else if (where === 'r') g = so.createLinearGradient(0, 0, fade, 0);
    else if (where === 't') g = so.createLinearGradient(0, dh, 0, dh - fade);
    else g = so.createLinearGradient(0, 0, 0, fade);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
    so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    sx.drawImage(soft, 0, 0);
    x.drawImage(sharp, dx, dy);
  }

  /* ---------- "How should we fill the ends?" (busy designs on banners wider than 3:1 or taller than 1:3) ---------- */
  function askEnds(card, img) {
    if (S.busy || !S.batch) return;
    let panel = $('.abi__ends', card);
    if (panel) { panel.hidden = false; card.classList.add('is-asking'); $('[data-ends="smooth"]', panel).focus(); return; }
    const b = S.batch, real = b.w / b.h, wide = real > img.w / img.h;
    const k = `abi-ends-${++uid}`;
    panel = document.createElement('div');
    panel.className = 'abi__ends';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-labelledby', k);
    panel.innerHTML = `
      <p class="abi__ends-t" id="${k}"><b>How should we fill the ends?</b></p>
      <div class="abi__ends-opts">
        <button type="button" class="abi__endopt is-rec" data-ends="smooth"><span class="abi__endpic"></span><b>Smooth ends</b><small>A soft blend of the edge colors. Recommended</small></button>
        <button type="button" class="abi__endopt" data-ends="stretch"><span class="abi__endpic"></span><b>Stretched ends</b><small>The edges stretched out as they are</small></button>
      </div>
      <button type="button" class="abi__ends-back">Pick another design</button>`;
    $('.abi__ends-t', panel).append(` Your ${flagShort(b.flag)} is ${b.rot ? 'longer' : (wide ? 'wider' : 'taller')} than this design, so we fill the ${endsWhere(b, wide)} ends from its edges. Its edges are busy, so stretched ends may look streaky.`);
    const im = $('.abi__img', card);
    [['smooth', true], ['stretch', false]].forEach(([key, smooth]) => {
      try { $(`[data-ends="${key}"] .abi__endpic`, panel).appendChild(flagPic(im, b, smooth, 340)); } catch (e) { /* preview not drawable: the labels still explain it */ }
      $(`[data-ends="${key}"]`, panel).addEventListener('click', () => { closeEnds(card); track('ardor_flag_ai_ends', { ends: key }); useDesign(img.id, key); });
    });
    $('.abi__ends-back', panel).addEventListener('click', () => { closeEnds(card); $('[data-act="use"]', card).focus({ preventScroll: true }); });
    $('.abi__card-actions', card).before(panel);
    card.classList.add('is-asking');
    $('[data-ends="smooth"]', panel).focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function closeEnds(card) { const p = $('.abi__ends', card); if (p) p.hidden = true; card.classList.remove('is-asking'); }

  /* ---------- results ---------- */
  let uid = 0;
  function cardFor(img, i, fixed) {
    const b = S.batch;
    const real = b.w / b.h;
    const art = img.w > 0 && img.h > 0 ? img.w / img.h : clampAr(real);
    const ext = Math.abs(real - art) / art > 0.03;
    const flagged = !!(img.check && img.check.ok === false);
    const n = i + 1;
    const k = `abi-fix-${++uid}`;
    const card = document.createElement('article');
    card.className = `abi__card${flagged ? ' is-flagged' : ''}`;
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-label', `Design ${n}`);
    card.dataset.id = img.id;
    const land = frameAr(b.flag) > 1.45;
    card.innerHTML = `
      <div class="abi__frame afl__frame${land ? ' is-land' : ''}" style="--ar:${frameAr(b.flag)}">
        <div class="afl__mock"><canvas class="afl__cv" aria-hidden="true"></canvas></div>
        <div class="afl__flat"><img class="abi__img" alt="" decoding="async"><small class="afl__cap">Flat artwork</small></div>
        ${fixed ? '<span class="abi__badge">Fixed</span>' : ''}
      </div>
      ${ext ? '<p class="abi__extnote"></p>' : ''}
      ${flagged ? '<p class="abi__flag"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5 2.5 20h19L12 3.5zM12 10v4.5M12 17.5v.01"/></svg><span>This one may have a spelling or logo mistake — use Fix a word or pick another.</span></p>' : ''}
      <p class="abi__cerr" role="alert" hidden></p>
      <div class="abi__card-actions">
        <button type="button" class="ws-btn abi__use" data-act="use">Use this design<span class="abi__vh"> (design ${n})</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
        <button type="button" class="ws-btn ws-btn--ghost abi__fixbtn" data-act="fix" aria-expanded="false" aria-controls="${k}">Fix a word<span class="abi__vh"> (design ${n})</span></button>
      </div>
      <form class="abi__fix" id="${k}" hidden novalidate>
        <label class="abi__flabel" for="${k}-in">What should we fix?</label>
        <div class="abi__fix-row">
          <input id="${k}-in" class="abi__input" type="text" maxlength="${LIMITS.fix}" autocomplete="off">
          <button type="submit" class="ws-btn ws-btn--ghost">Fix it</button>
        </div>
        <small class="abi__fix-left"></small>
      </form>
      <div class="abi__busy" hidden><span class="abi__spin" aria-hidden="true"></span><b class="abi__busy-t"></b><small class="abi__busy-s"></small><span class="abi__busy-bar" aria-hidden="true"><i></i></span></div>`;
    const im = $('.abi__img', card);
    im.alt = `Flag design ${n}: ${b.lines.headline}`;
    im.addEventListener('load', () => {
      card.classList.add('is-in');
      try { drawFlag($('.afl__cv', card), im, b.flag, b.rot, false, 720); } catch (e) { card.classList.add('no-mock'); }
      if (!ext) return;
      let eb = null;
      try { eb = edgeBusy(im, real > art); } catch (e) { /* image not readable: keep the plain note */ }
      if (!eb || !eb.busy) return;
      card.dataset.busy = '1';
      const note = $('.abi__extnote', card);
      note.classList.add('is-warn');
      note.textContent = `Busy edges: the stretched ${endsWhere(b, real > art)} ends of this design may look streaky. When you use it, you can pick smooth ends instead.`;
    });
    im.addEventListener('error', () => card.classList.add('is-broken'));
    im.crossOrigin = 'anonymous'; // the flag preview and the busy-edge check read the pixels (the worker sends CORS *)
    im.src = img.url;
    if (ext) $('.abi__extnote', card).textContent = `We stretch the plain ${endsWhere(b, real > art)} ends to fill your ${flagShort(b.flag)}.`;
    const fixForm = $('.abi__fix', card);
    const fixIn = $('input', fixForm);
    const fixBtn = $('[data-act="fix"]', card);
    fixIn.placeholder = 'e.g. Change "Snohomsh" to "Snohomish"';
    $('.abi__fix-left', card).textContent = fixesText();
    $('[data-act="use"]', card).addEventListener('click', () => (card.dataset.busy ? askEnds(card, img) : useDesign(img.id)));
    fixBtn.addEventListener('click', () => {
      const open = fixForm.hidden;
      fixForm.hidden = !open;
      fixBtn.setAttribute('aria-expanded', String(open));
      if (!open) return;
      const wrong = img.check && Array.isArray(img.check.wrong) ? img.check.wrong.find((x) => x && x.expected && x.seen) : null;
      if (wrong && !fixIn.value) fixIn.value = `Change "${wrong.seen}" to "${wrong.expected}"`;
      fixIn.focus();
    });
    fixForm.addEventListener('submit', (e) => { e.preventDefault(); fixDesign(img.id, fixIn.value); });
    if (S.busy) $$('button, input', card).forEach((el) => { el.disabled = true; });
    return card;
  }
  function renderResults() {
    const b = S.batch;
    if (!b || !b.images || !b.images.length) { results.hidden = true; return; }
    results.hidden = false;
    loading.hidden = true;
    againRow.hidden = false;
    fineEl.hidden = false;
    echo.textContent = b.lines.headline;
    metaEl.textContent = `${flagLabel(b.flag)} · ${STYLES[b.style] || ''}`;
    grid.dataset.shape = 'flag';
    grid.innerHTML = '';
    b.images.forEach((img, i) => grid.appendChild(cardFor(img, i, !!img.fixedFrom)));
    const bad = b.images.filter((x) => x.check && x.check.ok === false).length;
    if (bad && bad === b.images.length) statusEl.textContent = 'These may have a mistake. Use Fix a word or make another set.';
    else statusEl.textContent = b.images.length > 1 ? `${b.images.length} designs ready. Pick your favorite.` : 'Your design is ready.';
  }
  function remember() {
    const L = S.logo;
    sset(LAST_KEY, {
      at: Date.now(),
      batch: S.batch,
      form: { flag: S.flag, dir: S.pref, style: S.style, notes: notesIn.value, headline: lineIns.headline.value, subline: lineIns.subline.value, details: lineIns.details.value },
      logo: L && L.id ? { id: L.id, name: L.name, w: L.w, h: L.h, thumbData: L.thumbData } : null
    });
  }

  /* ---------- generate / fix / final ---------- */
  async function generate() {
    if (S.busy || S.off) return;
    const v = readForm(true);
    if (!v) return;
    if (!S.hasEmail && S.bannersLeft === 0) { S.pending = { kind: 'generate', run: generate }; openGate(); return; }
    showErr('');
    const prev = S.batch;
    startGenLoading(v);
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    let logoId = '';
    if (v.hasLogo) {
      try {
        logoId = await uploadLogo();
      } catch (j) {
        stopGenLoading();
        S.batch = prev;
        renderResults();
        showErr((j && j.message) || "We couldn't upload your logo. Try another file, or remove it and try again.");
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    const token = await botToken();
    const body = withEmail({ visitor, token, product: 'banner', widthFt: v.w, heightFt: v.h, style: v.style, styleNotes: v.notes, lines: v.lines });
    if (logoId) body.logoId = logoId;
    const j = await api('/api/banner/generate', body);
    stopGenLoading();
    if (j.bannersLeft != null) S.bannersLeft = j.bannersLeft;
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      S.batch = prev;
      renderResults();
      if (j.error === 'need_email') {
        S.bannersLeft = 0;
        setQuota();
        S.pending = { kind: 'generate', run: generate };
        openGate();
        return;
      }
      showErr(j.message || "We couldn't make your designs this time. Please try again.");
      setQuota();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
    S.batch = {
      batchId: j.batchId || '', aspect: j.aspect, clamped: !!j.clamped,
      w: v.w, h: v.h, flag: v.flag, dir: v.dir, rot: v.rot, style: v.style, notes: v.notes, lines: v.lines,
      logoId: logoId || null, images: j.images.slice(0, 8)
    };
    setQuota();
    renderResults();
    remember();
    h2.focus({ preventScroll: true });
    track('ardor_flag_ai_generated', { style: v.style, flag: v.flag, dir: v.dir, logo: !!logoId, shown: j.images.length });
  }

  async function fixDesign(id, text) {
    if (S.busy) return;
    const card = findCard(id);
    if (!card) return;
    const input = $('.abi__fix input', card);
    const fix = clean(text).slice(0, LIMITS.fix);
    if (fix.length < 2) { cardErr(card, 'Tell us what to fix, like: Change "Snohomsh" to "Snohomish".'); input.focus(); return; }
    if (!S.hasEmail && S.fixesLeft === 0) { S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Fixing it…', 'Redoing just that part', 14);
    statusEl.textContent = 'Fixing your design…';
    const token = await botToken();
    const j = await api('/api/banner/fix', withEmail({ visitor, token, imageId: id, fix }));
    done();
    S.busy = false;
    setBusyUi(false);
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      setQuota();
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.fixesLeft = 0; S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
      cardErr(card, j.message || 'That fix did not work. Please try again.');
      return;
    }
    const idx = S.batch.images.findIndex((x) => x.id === id);
    const next = Object.assign({}, j.images[0], { fixedFrom: id });
    S.batch.images[idx] = next;
    const fresh = cardFor(next, idx, true);
    card.replaceWith(fresh);
    setQuota();
    remember();
    statusEl.textContent = next.check && next.check.ok === false
      ? 'Here is your fixed design. It may still have a mistake, so check it closely.'
      : 'Here is your fixed design.';
    $('[data-act="use"]', fresh).focus({ preventScroll: true });
    track('ardor_flag_ai_fixed', { style: S.batch.style });
  }

  function validBox(lb) {
    return Array.isArray(lb) && lb.length === 4 && lb.every((n) => typeof n === 'number' && Number.isFinite(n)) ? lb.map((n) => Math.min(1, Math.max(0, n))) : null;
  }
  function handoffUrl(aiId, b, logoId, lb, ends) {
    let u = `${BUILDER}${BUILDER.indexOf('?') === -1 ? '?' : '&'}ai=${enc(aiId)}&flag=${enc(b.flag || DEFAULT_FLAG)}&rot=${b.rot ? -90 : 0}&sides=1`;
    if (ends === 'smooth') u += '&ends=smooth';
    if (logoId) {
      u += `&logo=${enc(logoId)}`;
      if (lb) u += `&lb=${lb.map((n) => n.toFixed(4)).join(',')}`;
    }
    return u;
  }
  async function useDesign(id, ends) {
    if (S.busy || !S.batch) return;
    const card = findCard(id);
    const b = S.batch;
    const img = b.images.find((x) => x.id === id);
    if (!card || !img) return;
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Making a sharp, print-ready version…', 'about 30–60 seconds', 25);
    statusEl.textContent = 'Making a sharp, print-ready version… about 30–60 seconds.';
    const token = await botToken();
    const j = await api('/api/banner/final', withEmail({ visitor, token, imageId: id }));
    if (j.finalsLeft != null) S.finalsLeft = j.finalsLeft;
    if (!j.ok || !j.image || !j.image.id) {
      done();
      S.busy = false;
      setBusyUi(false);
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.pending = { kind: 'final', run: () => useDesign(id, ends) }; openGate(); return; }
      cardErr(card, j.message || "We couldn't make the print version. Please try again.");
      return;
    }
    const fin = j.image;
    const lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
    const url = handoffUrl(fin.id, b, b.logoId, lb, ends);
    const fl = flagOf(b.flag);
    const pick = {
      v: 1, ai: fin.id, url: fin.url, w: fin.w || 0, h: fin.h || 0,
      flag: b.flag, shape: fl ? fl.shape : '', flagName: fl ? flagLabel(fl.k) : '',
      rot: b.rot ? -90 : 0, dir: b.dir || '', ends: ends === 'smooth' ? 'smooth' : 'stretch', sides: 1, pole: 'left',
      reqFt: { w: b.w, h: b.h }, logo: b.logoId || null, lb: lb || null,
      preview: id, lines: b.lines, style: b.style, at: Date.now()
    };
    sset(PICK_KEY, pick);
    remember();
    track('ardor_flag_ai_used', { style: b.style, flag: b.flag, dir: b.dir || '', logo: !!b.logoId, ends: ends || '' });
    $('.abi__busy-t', card).textContent = 'Opening the flag designer…';
    $('.abi__busy-s', card).textContent = '';
    statusEl.textContent = 'Opening the flag designer…';
    const ev = new CustomEvent('ardor:flag-ai-handoff', { bubbles: true, cancelable: true, detail: { url, pick, image: fin, preview: img, batch: b } });
    if (root.dispatchEvent(ev)) { window.location.assign(url); return; }
    done();
    S.busy = false;
    setBusyUi(false);
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); generate(); });
  againBtn.addEventListener('click', () => generate());
  editBtn.addEventListener('click', () => {
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => lineIns.headline.focus({ preventScroll: true }), 350);
  });

  /* ---------- email unlock (same as the sticker generator: Shopify customer form into a hidden iframe) ---------- */
  function openGate() {
    showErr('', gateErr);
    gateEmail.value = email || '';
    if (gateN) gateN.textContent = String(S.emailBanners);
    if (gate.showModal) { try { gate.showModal(); } catch (e) { gate.setAttribute('open', ''); } }
    else gate.setAttribute('open', '');
    setTimeout(() => gateEmail.focus(), 60);
    track('ardor_flag_ai_gate_shown', {});
  }
  function closeGate() { if (gate.close) gate.close(); else gate.removeAttribute('open'); }
  $('[data-abi-gate-close]').addEventListener('click', closeGate);
  gate.addEventListener('click', (e) => { if (e.target === gate) closeGate(); });
  function customerForm() {
    let f = root.querySelector('form#abi-customer');
    if (!f) {
      f = document.createElement('form');
      f.id = 'abi-customer';
      f.method = 'post';
      f.action = '/contact#abi-customer';
      f.className = 'abi__customer';
      f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,ai-flag-generator,ardor-flag-builder"><input type="hidden" name="contact[email]" data-abi-customer-email>';
      root.appendChild(f);
    }
    return f;
  }
  function subscribe(addr) {
    const f = customerForm();
    const field = f.querySelector('[name="contact[email]"]');
    if (field) field.value = addr;
    f.target = 'abi-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) { /* ignore */ } }
  }
  gateForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const addr = gateEmail.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', gateErr); gateEmail.focus(); return; }
    email = addr;
    store.set('wsIdeaEmail', addr);
    S.hasEmail = true;
    subscribe(addr);
    track('ardor_flag_ai_email', {});
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}&email=${enc(addr)}`);
    if (q.ok) {
      S.bannersLeft = q.bannersLeft;
      S.fixesLeft = q.fixesLeft;
      S.finalsLeft = q.finalsLeft;
      if (q.emailBanners) S.emailBanners = q.emailBanners;
    }
    setQuota();
    closeGate();
    const next = S.pending;
    S.pending = null;
    if (next && !(next.kind === 'generate' && S.bannersLeft === 0)) next.run();
  });

  /* ---------- start ---------- */
  Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
  syncCount('notes', notesIn);
  const params = new URL(window.location.href).searchParams;
  const last = sget(LAST_KEY);
  if (last && last.form && Date.now() - (last.at || 0) < 36e5 * 24) {
    const f = last.form;
    lineIns.headline.value = f.headline || '';
    lineIns.subline.value = f.subline || '';
    lineIns.details.value = f.details || '';
    notesIn.value = f.notes || '';
    Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
    syncCount('notes', notesIn);
    setStyle(f.style || 'bold');
    if (f.flag && flagOf(f.flag)) setFlag(f.flag, f.dir);
    if (last.logo && last.logo.id) setLogo({ blob: null, id: last.logo.id, name: last.logo.name, w: last.logo.w, h: last.logo.h, thumb: last.logo.thumbData, thumbData: last.logo.thumbData });
    if (last.batch && last.batch.images && last.batch.images.length) { S.batch = last.batch; renderResults(); }
  }
  const pf = String(params.get('flag') || '').toUpperCase();
  const pfl = FLAGS.find((x) => x.k.toUpperCase() === pf);
  const pd = params.get('dir');
  setFlag(pfl ? pfl.k : S.flag, pd === 'up' || pd === 'across' ? pd : S.pref);

  (async () => {
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}${email ? `&email=${enc(email)}` : ''}`, null, 20000);
    if (!q.ok) return;
    if (q.enabled === false) {
      S.off = true;
      goBtn.disabled = true;
      showErr('The flag generator is taking a short break. Please try again later.');
    }
    S.bannersLeft = q.bannersLeft;
    S.fixesLeft = q.fixesLeft;
    S.finalsLeft = q.finalsLeft;
    S.hasEmail = !!q.hasEmail;
    if (q.freeBanners) S.freeBanners = q.freeBanners;
    if (q.emailBanners) S.emailBanners = q.emailBanners;
    setQuota();
  })();
  if (SITEKEY) loadTurnstile();
})();
